import React from "react";

export default ({ children }) => (
  <div style={{ maxWidth: 700 }} className="p-10 mx-auto">
    {children}
  </div>
);
